"use client";

import Link from "next/link";
import Image from "next/image";
import { MoreVertical } from "lucide-react";
import { DesktopHeader } from "../../components/desktop-header";
import { MobileHeader } from "../../components/mobile-header";
import { Button } from "@workspace/ui/components";

type TrainingFinalProps = {
  sessionId: string;
  trainingId: string;
};

export function TrainingFinal({ sessionId, trainingId }: TrainingFinalProps) {
  return (
    <div className="w-full min-h-screen flex flex-col max-w-full overflow-hidden">
      <DesktopHeader title="Marcus Challenge" />
      <MobileHeader />

      <div className="flex flex-auto max-w-full flex-col items-center justify-center w-full px-5">
        <div className="flex flex-col gap-[48px] items-center w-full">
          <div className="flex flex-col gap-[32px] items-center w-full">
            {/* Video */}
            <div className="flex aspect-video w-full lg:max-w-200 overflow-hidden relative rounded-3xl shadow-md">
              <Image src="/marcus.png" fill alt="marcus" />
            </div>

            {/* Text */}
            <div className="flex flex-col gap-[12px] items-center text-center w-full">
              <h1 className="font-extrabold leading-[40px] text-[#292524] text-[32px]">
                Good Job!
              </h1>
              <p className="leading-[26px] text-[#797268] text-[18px] text-balance">
                You completed the roleplay. Let's review what mattered.
              </p>
            </div>
          </div>

          {/* Button */}
          <Button variant="d-primary" asChild className="h-12">
            <Link href={`/training/feedback/${sessionId}`}>
              View session insights
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
